import {
  GET_HOMEPAGE_POPULAR_BETS_REQUEST,
  GET_HOMEPAGE_POPULAR_BETS_SUCCESS,
  GET_HOMEPAGE_POPULAR_BETS_FAILURE,

  TOP_POPULAR_BETS_WS_ODD_UPDATE,
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HOMEPAGE_POPULAR_BETS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HOMEPAGE_POPULAR_BETS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_HOMEPAGE_POPULAR_BETS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case TOP_POPULAR_BETS_WS_ODD_UPDATE:
      return {
        ...state,
        data: [
          ...action.payload
        ]
      };
    default:
      return state;
  }
};
